import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import { TableSimples, TableSimplesProps } from "../BasicComponents/DisplayDados/TableSimples";

export default function ChipWithDialogTableSimples({
    chipCount,
    dialogTitle,
    headers,
    rows,
    maxHeight,
    total
}: ChipWithDialogProps) {

    const [openDialog, setOpenDialog] = useState<boolean>()

    return (
        <>
            <Chip onClick={() => setOpenDialog(true)} label={chipCount} size="small" />
            {
                openDialog &&
                <Dialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    maxWidth='sm'
                    fullWidth
                    scroll="body"
                >
                    <DialogTitle>{dialogTitle}</DialogTitle>
                    <DialogContent>
                        <TableSimples {...{ headers, rows, maxHeight, total }} />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setOpenDialog(false)}>
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}

interface ChipWithDialogProps extends TableSimplesProps {
    chipCount: string
    dialogTitle: string
}